/*
 * @Author: huasheng-c 957461792@qq.com
 * @Date: 2024-12-21 13:30:44
 * @LastEditors: huasheng-c 957461792@qq.com
 * @LastEditTime: 2024-12-21 17:42:20
 * @FilePath: \IOT4CMS\src\layouts\baseLayout\projectSelect\index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import React, { FC, useEffect, useState } from 'react'

import { GlobalModelState } from '@/models/connect'
import { connect, Dispatch, Loading } from 'umi'
import OperatingCenterImg from '@/assets/images/operating-center-img.png'
import './index.less'
import ProjectSelectStyle from './components/ProjectSelectStyle'
import { queryProjectInfo } from '@/services/porjectManagement'
import { history } from 'umi'

export interface ProjectSelectProps {
	global: GlobalModelState
	dispatch: Dispatch
}

const ProjectSelect: FC<ProjectSelectProps> = ({ global, dispatch }) => {
	const [projectMessage, setProjectMessage] = useState<any[]>([])
	let uInfo: any = localStorage.getItem('userInfo')
	useEffect(() => {
		dispatch({
			type: 'global/queryProjectMenu',
			callback: async res => {
				let changeProjectData: any[] = []
				const newData = await res.map(async element => {
					const resData = await queryProjectInfo(element.value)
					if (resData.code !== 200) {
						console.log('出错了')
					}
					changeProjectData.push(resData.value)
				})
				await Promise.all(newData)
				setProjectMessage(changeProjectData)
			},
		})
	}, [])

	const onSelectChange = val => {
		dispatch({
			type: 'global/save',
			payload: {
				showProjectSelect: false,
			},
		})

		sessionStorage.setItem('_projectId', val.toString())
		history.replace('/blocOperatorHome') //默认选中集团运营首页
	}

	return (
		<div className="projectSelect-container">
			<div className="projectSelect-welcome">
				<div>Hi</div>
				<div>
					{JSON.parse(uInfo)?.nickName || global.userInfo?.nickName || '普'}
				</div>
				<div className="text-style">请选择你的入口</div>
			</div>
			<div className="projectSelect-content">
				<div className="projectSelect-left">
					<ProjectSelectStyle
						text="运营中心"
						image={OperatingCenterImg}
						// tips="在地运营"
					/>
				</div>
				<div className="projectSelect-right">
					{projectMessage?.map(val => {
						return (
							<ProjectSelectStyle
								key={val.projectId}
								text={val.name || '无'}
								image={val.computerCover || OperatingCenterImg}
								onTap={() => {
									onSelectChange(val.projectId)
								}}
								// tips="在地运营"
							/>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default connect(({ global }: { global: GlobalModelState }) => ({
	global,
}))(ProjectSelect)
